(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interactive-banner-wpp-custom"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.interactive-banner');
    if (!sections.length) return;

    const isMobile = () => window.innerWidth <= 768;

    sections.forEach((root) => {
      const buttonsWrapper = root.querySelector('.interactive-banner__buttons');
      const buttons = root.querySelectorAll('.interactive-banner__button');
      const bgContainer = root.querySelector('.interactive-banner__background');
      const bgLayer = root.querySelector('.interactive-banner__bg-layer');

      if (!buttonsWrapper || !buttons.length || !bgContainer || !bgLayer) return;

      const changeDesktopImage = (url) => {
        if (!url || isMobile()) return;
        const current = bgContainer.dataset.currentImage;
        if (current === url) return;

        bgContainer.dataset.currentImage = url;
        bgLayer.style.opacity = '0';
        window.setTimeout(() => {
          bgLayer.style.backgroundImage = 'url(' + url + ')';
          bgLayer.style.opacity = '1';
        }, 60);
      };

      const handleDesktopHover = (button) => {
        if (isMobile()) return;

        const url = button.dataset.desktopUrl || bgContainer.dataset.defaultDesktop;
        if (!url) return;

        const active = root.querySelector('.interactive-banner__button--active');
        if (active && active !== button) {
          active.classList.remove('interactive-banner__button--active');
          active.setAttribute('aria-selected', 'false');
        }

        button.classList.add('interactive-banner__button--active');
        button.setAttribute('aria-selected', 'true');

        changeDesktopImage(url);
      };

      buttons.forEach((button) => {
        button.addEventListener('mouseenter', () => handleDesktopHover(button));
        button.addEventListener('focus', () => handleDesktopHover(button));
        button.addEventListener('click', (e) => {
          // No mobile, os botões servem apenas como links e nunca alteram a imagem
          if (isMobile()) {
            if (button.getAttribute('href') === '#') e.preventDefault();
            return;
          }

          if (button.getAttribute('href') === '#') {
            e.preventDefault();
          }
          handleDesktopHover(button);
        });
      });

      buttonsWrapper.addEventListener('mouseleave', () => {
        if (isMobile()) return;

        const defaultUrl = bgContainer.dataset.defaultDesktop;
        if (!defaultUrl) return;

        const active = root.querySelector('.interactive-banner__button--active');
        if (active) {
          active.classList.remove('interactive-banner__button--active');
          active.setAttribute('aria-selected', 'false');
        }

        changeDesktopImage(defaultUrl);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
